import React, {useEffect, useState} from "react";
import "../DynaView/DynaInput.scss";
import DynaModal from "../Modal/DynaModal";
import DynaButton from "../DynaView/DynaButton";
import DynaInput from "../DynaView/DynaInput";
import axios from "axios";
import {toast} from "react-toastify";
import {prefixUrl} from "../../Utils/utilsData";

const AddAddressModal = ({onClose, onAdd, add, formvalues, type}) => {

  const [values, setValues] = useState({});
  const [formValid, setFormValid] = useState({
    fullName: true,
    title: true,
    mobile: true,
    address: true,
  });

  useEffect(() => {
    formvalues !== "" && setValues(formvalues);
  }, []);

  const modalDataHandle = () => {
    const requiredFields = ["fullName", "title", "mobile", "address"];
    let isValid = true;

    for (const field of requiredFields) {
      if (!values[field]) {
        setFormValid((prevState) => ({
          ...prevState,
          [field]: false,
        }));
        isValid = false;
      }
    }

    if (!isValid) {
      toast.error("لطفا فیلدها را به درستی پر کنید.");
      return;
    }

    const mobileRegex = /^09\d{9}$/;

    if (type === "add" && !mobileRegex.test(values.mobile)) {
      setFormValid({
        ...formValid,
        mobile: false,
      });
      toast.error("شماره موبایل باید با 09 شروع شود و 11 رقم باشد");
      return;
    }

    if (type === "edit" && !mobileRegex.test(values.mobile)) {
      setFormValid({
        ...formValid,
        mobile: false,
      });
      toast.error("شماره موبایل باید با 09 شروع شود و 11 رقم باشد");
      return;
    }

    const endPoint = type === "add" ? "/address/add.php" : "/address/edit.php";
    axios.post(`${prefixUrl()}${endPoint}`, values).then((response) => {
      if (response.data.status) {
        toast.success(response.data.message);
        setTimeout(() => {
          onAdd(!add);
          onClose(false);
        }, 1000);
      } else {
        toast.error(response.data.message);
      }
    });
  };

  const handleInputChange = (e) => {
    const {name, value} = e.target;

    setFormValid({
      ...formValid,
      [name]: true,
    });

    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    if (type === "add") {
      axios.get(`${prefixUrl()}/address/default.php`).then((response) => {
        if (response.data.status) {
          values.fullName = response.data.message.fullName
          values.mobile = response.data.message.mobile
          setValues({...values})
        } else {
          toast.error("خطا در بر قراری ارتباط")
        }
      })
    }
  }, [type]);

  return (
    <DynaModal onClose={onClose} className={"simple-modal-address"}>
      <div className="header-modal">
        <p>{type === "add" ? "افزودن آدرس" : "ویرایش آدرس"}</p>

        <div onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <g
              stroke="#EB455F"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            >
              <path d="M13.99 10.01l.84-.84"></path>
              <path d="M9.17 14.83l2.75-2.75"></path>
              <path d="M14.83 14.83L9.17 9.17"></path>
              <path
                d="M4 6c-1.25 1.67-2 3.75-2 6 0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2c-1.43 0-2.8.3-4.03.85"></path>
            </g>
          </svg>
        </div>
      </div>

      <div className="content-modal">
        <div className="grid-form">
          <DynaInput
            typeMode={"input"}
            name="fullName"
            id="nameId"
            label=" نام و نام خانوادگی"
            type="text"
            placeholder="نام خود را وارد کنید"
            className={`ordibehesht-type ${
              formValid.fullName ? "" : "solid-login-type-error"
            }`}
            value={values?.fullName}
            onChange={handleInputChange}
          />
          <DynaInput
            typeMode={"input"}
            name="title"
            id="titleId"
            label="عنوان آدرس"
            type="text"
            placeholder="عنوان آدرس  را وارد کنید"
            className={`ordibehesht-type ${
              formValid.title ? "" : "solid-login-type-error"
            }`}
            value={values?.title}
            onChange={handleInputChange}
          />

          <DynaInput
            typeMode={"input"}
            name="mobile"
            id="mobileId"
            label="شماره موبایل"
            type="number"
            placeholder="شماره موبایل خود را وارد کنید"
            className={`ordibehesht-type ${
              formValid.mobile ? "" : "solid-login-type-error"
            }`}
            value={values?.mobile}
            onChange={handleInputChange}
          />
        </div>

        <p>
          در وارد کردن شماره موبایل خود دقت نمایید، زیرا کلیه موارد خرید و ارسال
          کالا از طریق پیامک به اطلاع شما خواهد رسید.
        </p>

        <DynaInput
          typeMode={"input"}
          name="address"
          id="nameId"
          label="آدرس"
          type="text"
          inputStyle={{width: "100%"}}
          placeholder="آدرس خود را وارد کنید"
          className={`ordibehesht-type ${
            formValid.address ? "" : "solid-login-type-error"
          }`}
          value={values?.address}
          onChange={handleInputChange}
        />
      </div>

      <div className="button-modal">
        <DynaButton className="brown-but" onClick={modalDataHandle}>
          {type === "add" ? "افزودن آدرس" : "ویرایش آدرس"}
        </DynaButton>
      </div>
    </DynaModal>
  );
};
export default AddAddressModal;
